import { Component, OnInit, Input } from '@angular/core';
import { GoogleTagManagerService } from 'app/_services/google-tag-manager.service';

@Component({
  selector: 'snc-privacy-notice',
  templateUrl: './snc-privacy-notice.component.html',
  styleUrls: ['./snc-privacy-notice.component.css']
})
export class SncPrivacyNoticeComponent implements OnInit {

  @Input('s-url-privacy-notice') urlPrivacyNotice: string;
  @Input('s-text-privacy-notice') textPrivacyNotice: string;
  @Input('s-text-btn-accept') textBtnAccept: string = 'Aceitar';
  @Input('s-text-btn-redirect') textBtnRedirect: string = 'Política de privacidade';

  hiddenPrivacyNotice: boolean = false;
  
  constructor(private gtmService: GoogleTagManagerService) { 
    this.hiddenPrivacyNotice = (localStorage.getItem("aviso-politica-privacidade-seguranca") == "true");
  }

  ngOnInit() {
  }

  public acceptPrivacyNotice() {
    localStorage.setItem("aviso-politica-privacidade-seguranca", "true");
    this.hiddenPrivacyNotice = true;
    this.sendEventGtm('CliqueAviso', 'botão aceitar');
  }

  public redirectPrivacyNotice() {
    window.open(this.urlPrivacyNotice);
    this.sendEventGtm('CliqueAviso', 'botão política');
  }

  public sendEventGtm(event: string, origem: string) {
    const gtmTag = {
      event: event,
      origem: origem,
    };

    this.gtmService.pushTag(gtmTag);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom/snc-privacy-notice/snc-privacy-notice.component.ts